<app-notifications></app-notifications>
@if (!(loading$ | async) && !userContextSvc.hasError) {
  <div style="width: 100%; /*overflow-x: hidden;*/" id="appContainer">
    <app-navbar></app-navbar>
    <router-outlet></router-outlet>
    <app-cookie-consent></app-cookie-consent>
  </div>
}

@if (userContextSvc.hasError) {
  <app-page403 />
}

@if (loading$ | async) {
  <div>
    <p-loader-info></p-loader-info>
  </div>
}
